export default __webpack_public_path__ + "static/media/attachment-ic-16px-normal.01625fac.svg";